"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.COMPONENT_NAME = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.arrow"));

var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.cheuron");

require("./circleImageSlider.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const COMPONENT_NAME = 'CircleImageSlider';
exports.COMPONENT_NAME = COMPONENT_NAME;

class CircleImageSlider extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "updateDimensions", () => {
      this.setState({
        width: window.innerWidth
      });
    });

    _defineProperty(this, "beforeChange", (oldIndex, newIndex) => {
      if (oldIndex !== newIndex) {
        this.setState({
          page: newIndex
        });
      }
    });

    _defineProperty(this, "slideToPrev", () => {
      this.slider.slickPrev();
    });

    _defineProperty(this, "slideToNext", () => {
      this.slider.slickNext();
    });

    this.state = {
      page: 0,
      width: window.innerWidth,
      components: this.props.components,
      textInfo1: this.props.textInfo1,
      taggingInfo: this.props.taggingInfo
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  render() {
    const {
      page,
      width,
      components,
      textInfo1,
      taggingInfo
    } = this.state;

    const mainTaggingInfo = _objectSpread(_objectSpread({}, taggingInfo), {}, {
      componentName: COMPONENT_NAME
    });

    const originalResponsive = [{
      breakpoint: 1100,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }, {
      breakpoint: 760,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 0,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }];
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: false,
      beforeChange: this.beforeChange,
      afterChange: this.afterChange,
      responsive: originalResponsive
    };

    const findBreak = () => {
      const widthSlider = width;
      let slides;
      let i = 0;
      let finish = false;

      while (i < settings.responsive.length && !finish) {
        if (settings.responsive[i].breakpoint <= widthSlider) {
          finish = true;

          if (i > 0) {
            slides = settings.responsive[i - 1].settings.slidesToShow;
          } else {
            slides = settings.slidesToShow;
          }
        } else {
          i += 1;
        }
      }

      return slides;
    };

    const slides = components.length;
    const leftArrowVisible = page > 0 && slides - findBreak() > 0;
    const rightArrowVisible = page < slides - findBreak();
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "CircleImageSlider",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({}, textInfo1)), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "CircleImageSlider-section",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: components.length <= findBreak() ? 'scrollSliderGapReduc' : 'scrollSliderGap',
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactSlick.default, _objectSpread(_objectSpread({
            ref: slider => {
              this.slider = slider;
            }
          }, settings), {}, {
            children: components.map(component => /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
              taggingInfo: _objectSpread(_objectSpread({}, mainTaggingInfo), {}, {
                componentContent: component.title && component.title.text
              }),
              link: component.link,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: "CircleImageSlider__container",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    className: "CircleImageSlider__container__image",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                      className: "CircleImageSlider__container__image-wrapper",
                      src: component.image,
                      alt: component.title
                    })
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    className: "CircleImageSlider__container__title",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, component.title), {}, {
                      className: "CircleImageSlider__container__title-wrapper"
                    }))
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    className: "CircleImageSlider__container__text",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, component.text), {}, {
                      className: "CircleImageSlider__container__text-wrapper"
                    }))
                  })]
                })
              })
            }))
          })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, {
            kind: _gerenciatdUnifiedicons.CHEURON_TYPES.LEFT,
            onClick: leftArrowVisible ? this.slideToPrev : () => {},
            visible: leftArrowVisible,
            taggingInfo: mainTaggingInfo,
            page2go: page,
            iconProps: {
              id: 'CircleCheuron',
              kind: _gerenciatdUnifiedicons.CHEURON_TYPES.LEFT,
              color: 'white',
              size: 12
            },
            size: "small",
            opacity: "op-0-6",
            bgColor: "black"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, {
            kind: _gerenciatdUnifiedicons.CHEURON_TYPES.RIGHT,
            onClick: rightArrowVisible ? this.slideToNext : () => {},
            visible: rightArrowVisible,
            taggingInfo: mainTaggingInfo,
            page2go: page,
            iconProps: {
              id: 'CircleCheuron',
              kind: _gerenciatdUnifiedicons.CHEURON_TYPES.RIGHT,
              color: 'white',
              size: 12
            },
            size: "small",
            opacity: "op-0-6",
            bgColor: "black"
          })]
        })
      })]
    });
  }

}

var _default = CircleImageSlider;
exports.default = _default;

//# sourceMappingURL=index.js.map